import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "audio-player" }
const _hoisted_2 = { class: "audio-player__times" }
const _hoisted_3 = { class: "audio-player__scrubber" }

import Slider from '@/components/common/Slider.vue'
import useAudioEngine from '@/composables/UseAudioEngine'
import timeFormat from '@/utils/time-format'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioPlayer',
  props: {
    currentTime: null,
    totalTime: null
  },
  setup(__props: any) {

const props = __props as {
  currentTime: number
  totalTime: number
};




const currentTimeFormatted = computed(() => {
  return timeFormat(audioSeekSliderModel.value)
})

const totalTimeFormatted = computed(() => {
  return timeFormat(props.totalTime)
})

const { seekAudio } = useAudioEngine()

const audioSeekSliderModel = ref(0)
const sliderDragging = ref(false)

watch(() => props.currentTime, () => {
  if (!sliderDragging.value) {
    audioSeekSliderModel.value = props.currentTime
  }
})

const onUpdateAudioSlider = (value: number) => {
  sliderDragging.value = true
  audioSeekSliderModel.value = value
}

const onChangeAudioSlider = () => {
  sliderDragging.value = false
  seekAudio(audioSeekSliderModel.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(currentTimeFormatted)), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(totalTimeFormatted)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Slider, {
        class: "audio-player__slider",
        min: 0,
        max: __props.totalTime,
        step: 0.01,
        modelValue: audioSeekSliderModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => onUpdateAudioSlider(value)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (onChangeAudioSlider())),
        onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, null, 8, ["max", "step", "modelValue"])
    ])
  ]))
}
}

})